import { render } from "./Search.view.vue?vue&type=template&id=23d0c4e3"
import script from "./Search.view.vue?vue&type=script&lang=js"
export * from "./Search.view.vue?vue&type=script&lang=js"

import "./Search.view.vue?vue&type=style&index=0&id=23d0c4e3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__